import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {Root, Article} from './routes/root';
import Error404Component from "./404";
import reportWebVitals from './reportWebVitals';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";


const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        errorElement: <Error404Component />,
    },
    {
        path: "/articles/*",
        element: <Article />
    }
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router}></RouterProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
